import AxiosInstance from "./Axios";
import Cookies from "universal-cookie";

const API_BASE = "/admin/rules-payment-filter";

export async function getAllRules() {
  try {
    const cookies = new Cookies();
    const token = cookies.get("token");

    return await AxiosInstance.get(API_BASE, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error) {
    console.error("error fetching payment rules:", error);
    return null;
  }
}

export async function createRule(payload) {
  try {
    const cookies = new Cookies();
    const token = cookies.get("token");
    return await AxiosInstance.post(API_BASE, payload, { headers: { Authorization: "Bearer " + token } });
  } catch (error) {
    console.error("error in request:", error);
    return null;
  }
}

export async function updateRule(payload) {
  try {
    const cookies = new Cookies();
    const token = cookies.get("token");
    return await AxiosInstance.put(API_BASE, payload, { headers: { Authorization: "Bearer " + token } });
  } catch (error) {
    console.error("error in request:", error);
    return null;
  }
}

export async function deleteRule(ruleId) {
  try {
    const cookies = new Cookies();
    const token = cookies.get("token");
    return await AxiosInstance.delete(API_BASE + "?id=" + ruleId, { headers: { Authorization: "Bearer " + token } });
  } catch (error) {
    console.error("error in request:", error);
    return null;
  }
}

const PaymentRulesService = {
  getAllRules,
  createRule,
  updateRule,
  deleteRule,
};

export default PaymentRulesService;
